import React from "react";

export const ProductImageView = ({ files, filesDescs, media_types, content_types }) => {
  const genFileIndex = (file) => {
    const name = file.fileName || file.name || file.file_name;
    return name.split(" ").join("");
  };

  return (
    <div>
      <div className="pt-2 pb-3">
        <i className="fa fa-camera" /> Product Image
      </div>
      
      {files?.length === 0 && (
        <div className="my-5 text-center">
          <p className="text-muted">No image available</p>
        </div>
      )}

      <div className="row">
        {files?.map((file, index) => {
          let fileIndex = genFileIndex(file);
          if (!files[fileIndex] && file.fileIndex) fileIndex = file.fileIndex;

          return (
            <div className="col-md-4 mb-3" key={index}>
              <div className="d-flex align-items-center">
                <div style={{ width: "50%", height: 200 }}>
                  <img
                    src={file.url}
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                      borderRadius: 4,
                      marginBottom: 20,
                      cursor: "pointer",
                    }}
                  />
                </div>
                <div className="mx-3">
                  <div>
                    <div className="text-secondary">Description</div>
                    <p>{filesDescs[fileIndex]?.media_desc || "-"}</p>
                  </div>
                  <div className="mb-3">
                    <div className="text-secondary">Image Types</div>
                    {filesDescs[fileIndex]?.media_types?.map((item) => {
                      const mediaType = media_types.find((type) => type.code === item);
                      return (
                        <div key={item} className="badge badge-warning mr-1">
                          {mediaType ? mediaType.name : item}
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    <div className="text-secondary">Content Types</div>
                    {filesDescs[fileIndex]?.content_types?.map((item) => {
                      const contentType = content_types.find((type) => type.code === item);
                      return (
                        <div key={item} className="badge badge-warning mr-1">
                          {contentType ? contentType.name : item}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
